// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.paragraph-text {
  color: var(--secondary, #373F50);
  font-family: Source Sans Pro;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 141.7%;
}

.title-photo-title-line-1 {
  color: var(--gray-lightest, #373F50);
  font-family: Source Sans Pro;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.title-photo-title-line-2 {
  color: #373F50;
  font-family: Source Sans Pro;
  font-size: 36px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.title-photo-title-line-3 {
  color: var(--gray-light, #373F50);
  font-family: Source Sans Pro;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding-top: 10px;
}

.meta-info-label {
  color: var(--secondary, #373F50);
  font-family: Source Sans Pro;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 160%;
  /* 25.6px */
}

.meta-info-field {
  color: var(--secondary, #373F50);
  font-family: Source Sans Pro;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
}

.row-padding-top-20 {
  padding-top: 20px;
}

.row-padding-top-40 {
  padding-top: 40px;
}

.italic-placeholder::placeholder {
  font-style: italic;
}`, "",{"version":3,"sources":["webpack://./src/components/manage_content/content_brief/content_brief_workflow/step_three/step-three.scss"],"names":[],"mappings":"AAAA;EACC,gCAAA;EACC,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AACF;;AACA;EACC,oCAAA;EACC,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAEF;;AAAA;EACC,cAAA;EACC,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAGF;;AADA;EACC,iCAAA;EACC,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AAIF;;AAFA;EACC,gCAAA;EACC,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;AAKF;;AAHA;EACC,gCAAA;EACC,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAMF;;AAJA;EACC,iBAAA;AAOD;;AAJA;EACC,iBAAA;AAOD;;AALA;EACE,kBAAA;AAQF","sourcesContent":[".paragraph-text {\n\tcolor: var(--secondary, #373F50);\n\t\tfont-family: Source Sans Pro;\n\t\tfont-size: 16px;\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tline-height: 141.7%;\n}\n.title-photo-title-line-1 {\n\tcolor: var(--gray-lightest, #373F50);\n\t\tfont-family: Source Sans Pro;\n\t\tfont-size: 24px;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tline-height: normal;\n}\n.title-photo-title-line-2 {\n\tcolor: #373F50;\n\t\tfont-family: Source Sans Pro;\n\t\tfont-size: 36px;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tline-height: normal;\n}\n.title-photo-title-line-3 {\n\tcolor: var(--gray-light, #373F50);\n\t\tfont-family: Source Sans Pro;\n\t\tfont-size: 20px;\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tline-height: normal;\n\t\tpadding-top: 10px\n}\n.meta-info-label {\n\tcolor: var(--secondary, #373F50);\n\t\tfont-family: Source Sans Pro;\n\t\tfont-size: 16px;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tline-height: 160%;\n\t\t/* 25.6px */\n}\n.meta-info-field {\n\tcolor: var(--secondary, #373F50);\n\t\tfont-family: Source Sans Pro;\n\t\tfont-size: 16px;\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tline-height: 160%;\n}\n.row-padding-top-20 {\n\tpadding-top: 20px;\n}\n\n.row-padding-top-40 {\n\tpadding-top: 40px;\n}\n.italic-placeholder::placeholder {\n  font-style: italic;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
